import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

export default function DeleteSurveyCategory({
  category,
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [error, setError] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const handleButtonClick = () => {
    setConfirmationOpen(true);
  };

  const handleConfirm = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/survey/category/${category.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: ` ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(
          errorResponse.error?.message || "Failed to delete category"
        );
      }

      fetchData(true);
      setMessage("Category deleted successfully");
      setSnackbarOpen(true);
      setConfirmationOpen(false);
    } catch (error) {
      setError(`Failed to delete category: ${error.message}`);
    }
  };

  const handleCancel = () => {
    setConfirmationOpen(false);
    setError(null);
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: "pointer", textTransform: "none", fontSize: "inherit" }}
        onClick={handleButtonClick}
      >
        Delete Category
      </Button>
      <Dialog
        open={confirmationOpen}
        onClose={handleCancel}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to delete category{" "}
            <strong>"{category.category}"</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
